module.exports = __webpack_public_path__ + "static/media/logo-dark.f0d143b9.png";